import { render, staticRenderFns } from "./scorecard-order-settings.vue?vue&type=template&id=78753b5c&scoped=true"
import script from "./scorecard-order-settings.vue?vue&type=script&lang=js"
export * from "./scorecard-order-settings.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-settings.vue?vue&type=style&index=0&id=78753b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78753b5c",
  null
  
)

export default component.exports